import React from 'react';
import dolphinIcon from '../../../public/static/images/dolphin.png';
import iconCreatureGroup from '../../../public/static/images/iconCreatureGroup.png';
import rainbowArrow from '../../../public/static/images/rainbowArrow.png';
import pixelPhone from '../../../public/static/images/pixelPhone.png';
import {
  CHAT_SCREEN_VIDEO,
  GENERATOR_GIF,
  TRANSFORM_LEFT_IMAGE,
  TRANSFORM_RIGHT_IMAGE,
} from '../../../constants';
import styles from './index.module.scss';


function GeneratorHighlightSection() {
  return (
    <div className={`${styles.sectionRow} ${styles.generatorRow}`}>
      <div className={styles.sectionCopy}>
        <h2 className={styles.sectionTitle}>
          Create a generator in seconds with our no-code builder.
        </h2>
        <p className={styles.sectionDescription}>
          Start by typing a couple of words or uploading an image to pull
          inspiration from. Watch as a small idea grows into something big.
        </p>
      </div>
      <div className={`${styles.sectionMedia} ${styles.generatorMedia}`}>
        <img src={GENERATOR_GIF} alt="" aria-hidden />
      </div>
    </div>
  );
}

function TransformHighlightSection() {
  return (
    <div className={`${styles.sectionRow} ${styles.transformRow}`}>
      <div className={styles.sectionCopy}>
        <img
          className={styles.sectionIcon}
          src={dolphinIcon}
          alt=""
          aria-hidden
        />
        <h2 className={`${styles.sectionTitle} ${styles.transformTitle}`}>
          Transform yourself and your closest friends
        </h2>
        <p className={styles.sectionDescription}>
          Give your friend an ’80s makeover. Send them back to medieval times to
          be a blacksmith. Turn your sister into a rat. Upload a photo and let
          BF Island do the rest.
        </p>
      </div>
      <div className={`${styles.sectionMedia} ${styles.transformMedia}`}>
        <div className={styles.transformCard}>
          <div className={styles.transformImagesRow}>
            <img
              className={`${styles.transformImage} ${styles.transformImageLeft}`}
              src={TRANSFORM_LEFT_IMAGE}
              alt="Before transform"
            />
            <img
              className={styles.transformArrow}
              src={rainbowArrow}
              alt=""
              aria-hidden
            />
            <img
              className={`${styles.transformImage} ${styles.transformImageRight}`}
              src={TRANSFORM_RIGHT_IMAGE}
              alt="After transform"
            />
          </div>
          <p className={styles.transformBubble}>
            This is what happens when you don’t answer the group chat for 5
            minutes.
          </p>
        </div>
      </div>
    </div>
  );
}

function ChatHighlightSection() {
  return (
    <div className={`${styles.sectionRow} ${styles.chatRow}`}>
      <div className={`${styles.sectionCopy} ${styles.chatCopy}`}>
        <div className={styles.chatDecor} aria-hidden>
          <img src={iconCreatureGroup} alt="" />
        </div>
        <h2 className={styles.sectionTitle}>
          Turn your group chat into the inside joke factory
        </h2>
        <p className={styles.sectionDescription}>
          Share memes, filters, and hyper-specific generators right inside your
          chat — no jumping between apps, no losing the moment. Build something
          in seconds that has a stranger scrolling back for context they’ll
          never find, but has your group losing it every time.
        </p>
      </div>
      <div className={`${styles.sectionMedia} ${styles.chatMedia}`}>
        <img
          src={pixelPhone}
          alt=""
          aria-hidden
          className={styles.pixelPhone}
        />
        <video
          className={styles.chatScreenOverlay}
          autoPlay
          loop
          muted
          playsInline
          aria-hidden
        >
          <source src={CHAT_SCREEN_VIDEO} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}

export default function Highlights() {
  return (
    <>
      <header className={styles.introHeader}>
        <h2 className={styles.introTitle}>On BF Island, you’ll be able to:</h2>
      </header>
      <GeneratorHighlightSection />
      <TransformHighlightSection />
      <ChatHighlightSection />
    </>
  );
}